import React from 'react';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  title: 'PE EMERGENCY LESSON KIT™',
  paragraphs: ['Ready-to-teach alternatives for limited equipment, no equipment, small spaces, indoor sessions, shortened classes and unexpected group changes.'],
  kicker: 'When Plan A fails, Plan B is ready.'
}, {
  num: '2',
  title: 'PE WARM-UP & COOL-DOWN TOOLKIT™',
  paragraphs: ['Ready-to-use warm-ups and lesson closers for coordination, agility, balance, movement, ball work, team activities and limited-space situations.'],
  kicker: 'Start better. Finish better. Plan less.'
}, {
  num: '3',
  title: 'PE STATION & CIRCUIT BUILDER™',
  paragraphs: ['Ready-to-run circuits with setup, rotations, station instructions, teaching cues and level adaptations.', 'Also includes simple frameworks for building your own circuits faster.'],
  kicker: 'Set up. Rotate. Teach.'
}, {
  num: '4',
  title: 'PE EQUIPMENT & SPACE ADAPTATION GUIDE™',
  paragraphs: ['Adapt activities when equipment, space or group size changes.', 'Modify distance, rules, targets, movement, equipment allocation and organization while keeping the lesson objective.'],
  kicker: 'Teach effectively with what you have.'
}, {
  num: '5',
  title: 'PE TEACHER QUICK-REFERENCE CARDS™',
  paragraphs: ['Quick-reference cards for movement skills, teaching cues, group organization, adaptations, progressions, setups and safety checks.'],
  kicker: 'Fast support when you need it.'
}];
const outcomes = [{
  emoji: '🏃',
  title: 'Ready-Made Lessons',
  desc: 'Use structured lessons instead of rebuilding every class.'
}, {
  emoji: '🎯',
  title: 'Organized Activities',
  desc: 'Find games and movement tasks faster.'
}, {
  emoji: '📈',
  title: 'Clear Skill Progressions',
  desc: 'Teach from simpler to more challenging levels.'
}, {
  emoji: '👥',
  title: 'Better Class Management',
  desc: 'Organize groups, stations and equipment more efficiently.'
}, {
  emoji: '📋',
  title: 'Ready-to-Use Assessment Tools',
  desc: 'Observe and track progress without creating everything yourself.'
}, {
  emoji: '⏱️',
  title: 'Less Planning',
  desc: 'Keep everything together in one professional system.'
}];
export function BonusSection() {
  return <>
      <section className="bg-brand-cream px-4 py-6 border-b border-brand-line" data-id="element-15" data-mp="yatbnjcf28rx">
        <div className="max-w-4xl mx-auto" data-id="element-16" data-mp="tfduoij43wra">
          <h2 className="font-display text-2xl sm:text-3xl text-brand-navy text-center mb-3" data-id="element-17" data-mp="174za5ixpdtuk">
            🎁 5 Premium Bonuses Included
          </h2>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-18" data-mp="12cy3ccjb0vbx">
            {bonuses.map(bonus => <div key={bonus.num} className="bg-white border-t-4 border-brand-orange rounded-b-xl p-3.5 shadow-sm flex flex-col" data-id="element-19" data-mp="en3ltho1iilc">
                <div className="flex items-center gap-2 mb-1.5" data-id="element-20" data-mp="imnmskcc657">
                  <GiftIcon className="w-4 h-4 text-brand-orange shrink-0" aria-hidden="true" data-id="element-21" data-mp="5ams8ybcvn84" />
                  <p className="font-heading font-extrabold text-[11px] text-brand-orange uppercase tracking-wider" data-id="element-22" data-mp="3moi3jaytuv40">
                    🎁 Bonus {bonus.num}
                  </p>
                </div>
                <h3 className="font-heading font-extrabold text-[13px] text-brand-navy leading-tight uppercase mb-1.5" data-id="element-23" data-mp="j7t6cfl4wxr0">
                  {bonus.title}
                </h3>
                {bonus.paragraphs.map(p => <p key={p} className="text-xs text-brand-slate font-medium leading-snug mb-1.5" data-id="element-24" data-mp="easyq08mzmxs">
                    {p}
                  </p>)}
                <p className="font-heading font-bold text-[11px] text-brand-green uppercase tracking-wide mt-auto" data-id="element-25" data-mp="2z1jtav1awjej">
                  {bonus.kicker}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="bg-white px-4 py-6 border-b border-brand-line" data-id="element-26" data-mp="3ag58tx718mzu">
        <div className="max-w-4xl mx-auto" data-id="element-27" data-mp="35j51liyg5e75">
          <div className="text-center mb-3" data-id="element-28" data-mp="35g0n9sr9p22r">
            <h2 className="font-display text-2xl sm:text-3xl text-brand-navy leading-[1.05]" data-id="element-29" data-mp="30kbklgjyb528">
              This isn't just more PE content
            </h2>
            <p className="font-heading font-extrabold text-sm sm:text-base text-brand-green uppercase tracking-wide" data-id="element-30" data-mp="3t7y09n6ge05g">
              It's a complete teaching system.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2.5" data-id="element-31" data-mp="3j9s0bb47j438">
            {outcomes.map(item => <div key={item.title} className="bg-brand-cream border-l-4 border-brand-navy rounded-r-lg p-3 flex gap-2.5 items-start" data-id="element-32" data-mp="2ctfzt3dwxa4h">
                <span className="text-xl shrink-0" aria-hidden="true" data-id="element-33" data-mp="27wxw86ubjhtq">
                  {item.emoji}
                </span>
                <div data-id="element-34" data-mp="sb4178g0w654">
                  <h3 className="font-heading font-extrabold text-[13px] text-brand-navy uppercase tracking-wide leading-tight mb-0.5" data-id="element-35" data-mp="scow4z691r3i">
                    {item.title}
                  </h3>
                  <p className="text-xs text-brand-slate font-medium leading-snug" data-id="element-36" data-mp="122i8i2e7ua8t">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}